import React, { Component } from "react";
import { Link } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";
import Fuse from "fuse.js";
import SelectDropDown from "../shared/drop-down/drop-down";
import SendLinkMerchant from "../modals/send-link-merchant";
import AlertForSendSignature from "../alerts/AlertForSendSignature";
import TransactionDetails from "./transaction-details";
import {
    getPreapp,
    UserData,
    Uploads,
    getPreappById,
    starApp,
    Logout,
    OrganisationData,
    getUser,
    addNotes,
    deleteNote,
    addTodo,
    getTodo,
    updateTodo,
    deleteTodo,
    updateImportant,
    updateProgression,
    resendSignature,
    getFiles,
    getMerchantInfo,
    getNotes,
    bankList,
    runPdf,
    sendSignature,
    cancelApp,
    copyApp,
    changeOwner,
    cancelSignature,
    DeleteFile,
    GetOrganizationById,
    GetAllOrganizationsSingleCall,
    reviveApplication,
    getExportCSVLink,
} from "../../api/index";
import "../../../sass/applications.scss";
import ReactModal from "react-modal";
import InfiniteScroll from "react-infinite-scroll-component";
import MobileAppDetailHeader from "../preapps/MobileAppDetailHeader";
import BanksModal from "../modals/BanksModal";
import ColumnResizer from "react-column-resizer";
import StatusBar from ".././preapps/StatusBar";
import config from "../../config";
import PreappArow from "../preapp-rows/preapp-rows-for-merchant";
import ReactTooltip from "react-tooltip";
import StatusRightContent from "../preapp-rows/status-bar/right-info-status";
import Pusher from "pusher-js";
import ExportCSVModal from "../modals/export-csv-modal";

const fileDownload = require("js-file-download");
const STRATUS_URL = config.paymentcloud.STRATUS_URL;
const MAIN_URL = config.paymentcloud.MAIN_URL;
const default_bank = 1;
const default_index = 1;
const signature_ids = [7];
const awaiting_signature_request = 6;
const app_pending_pc_approval = 15;
const Prevet_Application = 19;
const Cancelled_Application = 14;
const awaiting_signature = 7;
const hide_progression = [
    awaiting_signature_request,
    app_pending_pc_approval,
    awaiting_signature,
    Prevet_Application,
];
const cancelled = 14;

const MOBILE_SCREEN_WIDTH = 767;

ReactModal.setAppElement("#root");
class MerchantAppList extends Component {
    typingTimer = null;

    constructor(props) {
        super(props);
        this.state = {
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            preapp: [],
            appData: {},
            user: {},
            showModal: false,
            showOwnerModal: false,
            file: "",
            activeId: null,
            check: [],
            action: "",
            tab: "tab2",
            detailsAccordion: [true, false, false, false, false, false],
            mobileMenu: true,
            organization_user: [],
            users_in_organization: [],
            organization_options: [],
            user_options: [],
            owner_selected_organization: null,
            selectedApp: [],
            selected_owner: "",
            search: "",
            searchInputShow: false,
            note: "",
            agent_text: "Send Agent Note",
            pci_text: "Send PCI Note",
            todo: false,
            add_todo: false,
            todo_text: "",
            todo_id: "",
            todo_list: {},
            FilterMenu: false,
            sortBy: "created_at",
            sortValue: "DESC",
            left_progression_filter: "active",
            page: 1,
            hasMore: true,
            filterBy: "no",
            pci_admin: false,
            showFilters: false,
            update: false,
            update_id: "",
            appkey: "",
            important: {},
            important_id: [],
            confirm: false,
            new_progression: "",
            relation_manager: [],
            selected_manager: "",
            filterToggle: true,
            progression_data: [
                {
                    value: 1,
                    label: "Back to Edit",
                },
                {
                    value: 8,
                    label: "Pre-Bank Review",
                },
                {
                    value: 9,
                    label: "Underwriting Review",
                },
                {
                    value: 10,
                    label: "In Consideration",
                },
                {
                    value: 11,
                    label: "Awaiting Reserve",
                },
                {
                    value: 12,
                    label: "Approved",
                },
                {
                    value: 13,
                    label: "Denied",
                },
                {
                    value: 14,
                    label: "Cancelled",
                },
                {
                    value: 15,
                    label: "App pending PC approval",
                },
                {
                    value: 16,
                    label: "Sent for Signature",
                },
                {
                    value: 17,
                    label: "PDF requested",
                },
                {
                    value: 18,
                    label: "Awaiting wet signature",
                },
            ],
            selected_progression: null,
            resend_sign: "",
            show_info: false,
            row_info: false,
            banks: {},
            selected_bank: "",
            show_banks: false,
            defaultBank: {
                id: "",
                name: "",
            },
            activeBank: "",
            note_app_id: "",
            bank_name: "",
            parent_id: "",
            selectedOption: "",
            confirmText: "",
            bank_id: "",
            app_id: null,
            is_parent: true,
            header_user_name: "",
            loggedInUser: {},
            options: {
                chart: {
                    type: "pie",
                    className: "pie-chart",
                    backgroundColor: "#fff",
                    height: "120px",
                },
                credits: {
                    enabled: false,
                },
                tooltip: {
                    enabled: true,
                    formatter: function () {
                        return "<b></b> <b>" + this.y + " %</b>";
                    },
                },
                crisp: true,
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        minSize: 80,
                        dataLabels: { enabled: false },
                    },
                },
                title: {
                    text: "",
                },
                hoverData: null,
                series: [
                    {
                        data: [
                            {
                                name: "Completed",
                                y: 0,
                                color: "green",
                            },
                            {
                                name: "In-Completed",
                                y: 100,
                                color: "red",
                            },
                        ],
                    },
                ],
            },
            showButtons: false,
            accordionNumber: 0,
            show_spinner: false,
            show_right_spinner: false,
            totalCount: 0,
            childParentID: "",
            showLoader: false,
            uploadFileTypeError: "",
            Searching: false,
            showAlert: false,
            alertHeader: "",
            alertMessage: "",
            showCreatedAppModel: false,
            selectedAppBankName: "",
            showExportCSVModal: false,
            showExportSpinner: false,
            showSendLinkModal: false,
            noteErrorMessage: "",
            uploadFileError: null,
            showMerchantInfoLoader: false,
        };
        this.uploads = [];
        this.uploadTitle = "";
        this.TitleArrray = [];
    }

    componentDidMount() {
        var user = {};
        UserData()
            .then((response) => {
                user = response;
                if (this.state.header_user_name.length === 0) {
                    this.setState(
                        {
                            header_user_name: user.name,
                            loggedInUser: user,
                        },
                        () => {},
                    );
                }
                OrganisationData()
                    .then((response) => {
                        this.state.user = user;
                        this.state.user.organization = response;
                        this.getallUser(response.id);
                        this.setState({});
                    })
                    .catch((error) => {});
            })
            .catch((error) => {
                if (error.status == 401) {
                    this.props.history.push("/");
                }
            });

        this.getPreappData();
        this.getTodoList();
        this.getOwnerOptions();
        window.addEventListener("resize", this.handleResize);
        let text_name = this.props.match.params.text
            ? this.props.match.params.text
            : null;
        if (text_name != null && typeof text_name !== "undefined") {
            let text_data = this.decrypt("salt", text_name);
            if (!localStorage.getItem(text_data)) {
                this.setState({
                    showAlert: true,
                    alertHeader: "Signature Sent",
                    alertMessage: text_data,
                });
                localStorage.setItem(text_data, true);
            }
        }
    }
    decrypt = (salt, encoded) => {
        const textToChars = (text) =>
            text.split("").map((c) => c.charCodeAt(0));
        const applySaltToChar = (code) =>
            textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded
            .match(/.{1,2}/g)
            .map((hex) => parseInt(hex, 16))
            .map(applySaltToChar)
            .map((charCode) => String.fromCharCode(charCode))
            .join("");
    };

    pusherSubscribe = (user) => {
        let channel_name = "";
        if (user.organization_id == 1 && user.role == "admin") {
            channel_name = "organization_all";
        } else {
            if (user.role == "admin") {
                channel_name =
                    "organization_" + user.organization_id + "_admin";
            } else {
                channel_name =
                    "organization_" +
                    user.organization_id +
                    "_agent" +
                    "_" +
                    user.id;
            }
        }
        const pusher = new Pusher(config.paymentcloud.PUSHER_KEY, {
            cluster: config.paymentcloud.PUSHER_CLUSTER,
        });

        var channel = pusher.subscribe(channel_name);
        channel.bind("App\\Events\\PowerappBackgroundUpdate", (data) => {
            if (
                data.message == "update_preapp" &&
                this.state.activeId == "" &&
                typeof this.state.left_progression_filter === "undefined" &&
                this.state.search == "" &&
                this.state.sortBy == "created_at" &&
                this.state.sortValue == "DESC" &&
                typeof this.state.progression_id === "undefined" &&
                typeof this.state.manager_id === "undefined"
            ) {
                this.getPreappData();
            }
        });
    };
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    fuzzySearch(options) {
        const fuse = new Fuse(options, {
            keys: ["name"],
            includeScore: true,
        });

        return (value) => {
            if (!value.length) {
                return options;
            }
            let result = fuse.search(value);
            let new_options = [];
            result.forEach((data) => new_options.push(data.item));
            return new_options;
        };
    }
    handleResize = () => {
        this.setState({
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        });
    };
    getOwnerOptions() {
        GetAllOrganizationsSingleCall()
            .then((response) => {
                let organization_options = [];
                if (response.organization && response.organization.length > 0) {
                    response.organization.forEach((organization) => {
                        organization_options.push({
                            label: organization.name,
                            value: organization.id,
                        });
                    });
                }
                this.setState({ organization_options: organization_options });
            })
            .catch((error) => {});
    }
    LeftProgressionFilter = (type) => {
        this.setState(
            {
                left_progression_filter: type,
                selected_manager: [],
                selected_progression: [],
                search: "",
            },
            function () {
                this.getPreappData();
            },
        );
    };
    SearchPreappData = () => {
        var query = {
            left_progression_filter: this.state.left_progression_filter,
            search: this.state.search || "",
            sortBy: this.state.sortBy || "",
            sortValue: this.state.sortValue || "",
            manager_id: this.state.selected_manager || [],
            progression_id: this.state.selected_progression || [],
            page: this.state.page,
            merchants: true,
        };
        if (this.state.showLoader === false) {
            this.setState({ showLoader: true }, function () {
                getPreapp(query)
                    .then((response) => {
                        let PreappDataTemp = this.state.preapp.concat(
                            response.data.data,
                        );
                        this.setState(
                            {
                                preapp: PreappDataTemp,
                                totalCount: response.total_count
                                    ? response.total_count
                                    : 0,
                                important: response.important,
                                important_id: [],
                                relationManager: response.relation_manager,
                                showFilters: false,
                                showLoader: false,
                                hasMore:
                                    response.data.data.length < 50
                                        ? false
                                        : true,
                            },
                            function () {
                                let ImportantIDTemp = [];
                                this.state.important.forEach((element) => {
                                    ImportantIDTemp.push(element.id);
                                });
                                this.setState({
                                    important_id: ImportantIDTemp,
                                });
                                if (response.default_bank) {
                                    this.setState({
                                        defaultBank: response.default_bank,
                                    });
                                }
                            },
                        );
                    })
                    .catch((error) => {
                        this.setState({
                            showFilters: false,
                            showLoader: false,
                        });
                    });
            });
        }
    };
    getPreappData(ResetData = true) {
        if (ResetData == true) {
            this.setState(
                {
                    preapp: [],
                    page: 1,
                    activeId: "",
                    show_info: false,
                    appkey: "",
                    note_app_id: "",
                    parent_id: "",
                    tab: "tab2",
                    row_info: true,
                    activeBank: "",
                    is_parent: true,
                },
                function () {
                    this.SearchPreappData();
                },
            );
        } else {
            this.SearchPreappData();
        }
    }

    getTodoList() {
        var query = "?";
        if (this.state.filterBy != "") {
            query += "is_completed=" + this.state.filterBy;
        }
        getTodo(query)
            .then((response) => {
                this.state.todo_list = response.data;
                this.setState({});
            })
            .catch((error) => {});
    }
    getallUser(organization_id) {
        getUser(organization_id)
            .then((response) => {
                this.setState({ pci_admin: response.is_pci });
                this.setState({ organization_user: response.user });
            })
            .catch((error) => {});
    }

    getUsersInOrganization() {
        getUser(this.state.appData.organization_id)
            .then((response) => {
                this.setState({ users_in_organization: response.user });
            })
            .catch((error) => {});
    }

    handleClick = (appId, key, important) => {
        let show_child = false;
        let info = false;

        if (this.state.preapp[key].child.length > 0) {
            show_child = true;
            if (appId === this.state.activeId) {
                show_child = !this.state.row_info;
                info = true;
            }
        } else {
            if (appId === this.state.activeId) {
                info = true;
            }
        }
        this.setState(
            {
                activeId: appId,
                show_info: info,
                appkey: key,
                note_app_id: "",
                parent_id: "",
                tab: "tab2",
                row_info: show_child,
                activeBank: "",
                is_parent: true,
                bankNameOfselectedPreap: "",
            },
            () => {
                this.getAppData();
            },
        );
    };

    handleChildAppClick = (appId, key, important) => {
        let info = false;
        this.setState(
            {
                activeId: appId,
                show_info: info,
                appkey: key,
                note_app_id: "",
                parent_id: "",
                tab: "tab2",
                row_info: true,
                activeBank: "",
                is_parent: true,
                bankNameOfselectedPreap: "",
            },
            () => {
                this.getAppData();
            },
        );
    };

    handleClickWithChild = (appId, key, important) => {
        let show_child = false;
        let info = false;
        if (this.state.preapp[key].child.length > 0) {
            if (this.state.childParentID === appId) {
                show_child = !this.state.row_info;
            } else {
                show_child = true;
            }
        }
        this.setState(
            {
                childParentID: appId,
                activeId: appId,
                show_info: info,
                appkey: key,
                note_app_id: "",
                parent_id: "",
                tab: "tab2",
                row_info: show_child,
                activeBank: "",
                is_parent: true,
                bankNameOfselectedPreap: "",
            },
            () => {
                if (
                    this.state.banks.length == undefined ||
                    this.state.banks.length <= 0
                ) {
                    this.getBankList();
                }
            },
        );
    };

    toggleSendLinkModal = (show) => {
        this.setState({ showSendLinkModal: show });
    };

    /*
     * Converts a Progression Id into a percentage value.
     */
    progression2Percentages(progressionId) {
        let completed = 0;
        let incomplete = 0;
        if (progressionId <= 6) {
            completed = 25;
            incomplete = 100 - completed;
        } else if (progressionId === 7 || progressionId === 18) {
            completed = 75;
            incomplete = 100 - completed;
        } else if (progressionId === 8 || progressionId === 15) {
            completed = 87.5;
            incomplete = 100 - completed;
        } else if (progressionId === 12 || progressionId === 14) {
            completed = 100;
            incomplete = 0;
        } else {
            completed = 75;
            incomplete = 100 - completed;
        }
        return [completed, incomplete];
    }
    CurrentProgressionName = (progressionId) => {
        if (this.state.loggedInUser?.channel == "sales_channel") {
            if (progressionId < 5) {
                return "Working Lead";
            }
            if (progressionId > 4 && progressionId < 10) {
                return "App in Progress";
            }
            if (progressionId > 9 && progressionId < 14) {
                return "Unworkable";
            }
            if (progressionId > 13 && progressionId < 17) {
                return "Underwriting";
            }
            if (progressionId > 16 && progressionId < 21) {
                return "Approved";
            }
            if (progressionId > 20 && progressionId < 23) {
                return "Declined";
            }
            return "";
        } else {
            switch (progressionId) {
                case 0:
                    return "Awaiting Preapp";
                case 1:
                    return "Awaiting Preapp";
                case 2:
                    return "Awaiting Business Profile";
                case 3:
                    return "Awaiting Pricing";
                case 4:
                    return "Awaiting Pricing Confirmation";
                case 5:
                    return "Awaiting For Equipments";
                case 6:
                    return "Awaiting Signature Request";
                case 7:
                    return "Awaiting Signature";
                case 8:
                    return "Pre-Bank Review";
                case 9:
                    return "Underwriting Review";
                case 10:
                    return "Pended";
                case 11:
                    return "Awaiting Reserve";
                case 12:
                    return "Approved";
                case 13:
                    return "Denied";
                case 14:
                    return "Cancelled";
                case 15:
                    return "App pending PC approval";
                case 16:
                    return "Sent for Signature";
                case 17:
                    return "PDF requested";
                case 18:
                    return "Awaiting wet signature";
                case 19:
                    return "Pending Prevet";
                case 20:
                    return "Prevet Approved";
                case 21:
                    return "Terminated";
                case 22:
                    return "Support";
            }
        }
        return "";
    };
    currentStatus(progressionId) {
        let status = 0;
        let complete = 0;
        if (progressionId == 1 || progressionId === 2) {
            status = 2;
            complete = 25;
        } else if (progressionId === 3 || progressionId === 4) {
            status = 4;
            complete = 50;
        } else if (progressionId === 5) {
            status = 5;
            complete = 62.5;
        } else if (progressionId === 6) {
            status = 6;
            complete = 75;
        } else if (
            progressionId === 7 ||
            progressionId === 8 ||
            progressionId === 15 ||
            progressionId === 18
        ) {
            status = 7;
            complete = 87.5;
        } else if (progressionId === 12 || progressionId === 14) {
            status = 8;
            complete = 100;
        } else {
            status = 6;
            complete = 75;
        }
        return [status, complete];
    }

    getAppData(updateAppRow, typeUpdate) {
        this.setState({ showMerchantInfoLoader: true });
        var app_id =
            this.state.note_app_id.length != 0
                ? this.state.note_app_id
                : this.state.activeId;
        getPreappById({ id: app_id })
            .then((response) => {
                const [completed, incomplete] = this.progression2Percentages(
                    response.data.progression_id,
                );

                this.setState(
                    {
                        appData: response.data,
                        options: {
                            chart: {
                                type: "pie",
                                className: "pie-chart",
                                backgroundColor: "#fff",
                                height: "120px",
                            },
                            credits: {
                                enabled: false,
                            },
                            tooltip: {
                                enabled: true,
                                formatter: function () {
                                    return "<b></b> <b>" + this.y + " %</b>";
                                },
                            },
                            crisp: true,
                            plotOptions: {
                                pie: {
                                    allowPointSelect: false,
                                    minSize: 80,
                                    dataLabels: { enabled: false },
                                },
                            },
                            title: {
                                text: "",
                            },
                            hoverData: null,
                            series: [
                                {
                                    data: [
                                        {
                                            name: "Completed",
                                            y: completed,
                                            color: "green",
                                        },
                                        {
                                            name: "In- Completed",
                                            y: incomplete,
                                            color: "red",
                                        },
                                    ],
                                },
                            ],
                        },
                        show_info: true,
                        selectedAppBankName: "",
                    },
                    () => {
                        this.updateList();
                        this.getAppInfo();
                        this.getAppNotes();
                        // this.getAppFiles();
                        this.getUsersInOrganization();
                        this.resetDetailsAccordion();
                    },
                );
                this.setState({ showMerchantInfoLoader: false });
                if (updateAppRow) {
                    this.updatePreappList(app_id, typeUpdate, response.data);
                }
            })
            .catch((error) => {});
    }

    updatePreappList = (app_id, typeUpdate, data) => {
        let preappList = this.state.preapp;
        const indexApp = preappList.findIndex((x) => x.id === app_id);
        if (typeUpdate === "organization") {
            preappList[indexApp].organization = data.organization;
            this.setState({ preapp: preappList });
        }
    };
    handleDrop = (event) => {
        this.uploads = event;
        this.setState({ file: 1 });
        this.handleOpenModal();
    };

    handleDropReject(event) {
        this.setState({
            uploadFileError: "File Is Too Large. Please choose less to 1MB",
        });
        this.handleCloseModal();
    }

    handlechange(event) {
        if (event.target.value != "") {
            this.uploadTitle = event.target.value;
        }
        this.setState({ uploadFileTypeError: "" });
    }

    handleShowOwnerModal() {
        this.setState({ showOwnerModal: true });
    }

    handleCloseOwnerModal = () => {
        this.setState({ showOwnerModal: false });
    };

    handleOwnerOrganizationChange(selected_org) {
        this.setState({ owner_selected_organization: selected_org });
        GetOrganizationById(selected_org).then((response) => {
            let user_options = [];
            if (response.users && response.users.length > 0) {
                response.users.forEach((user) => {
                    user_options.push({ label: user.name, value: user.id });
                });
            }
            this.setState({ user_options: user_options, selected_owner: "" });
        });
    }

    handleOwnerChange(selected_val) {
        this.setState({ selected_owner: selected_val });
    }

    handleUpdateOwner() {
        let data = {};
        data.change_ownership_user_id = parseInt(this.state.selected_owner);
        data.id = this.state.activeId;
        data.stratus = true;
        data.ajaxRequest = true;
        changeOwner(data)
            .then((response) => {
                if (response.status) {
                    this.setState(
                        {
                            showOwnerModal: false,
                            showAlert: true,
                            alertHeader: response.message,
                            users_in_organization: [],
                            owner_selected_organization: "",
                            selected_owner: "",
                        },
                        () => {
                            this.getAppData(true, "organization");
                        },
                    );
                }
            })
            .catch((error) => {});
    }

    handleEditApplication = () => {
        const EditAppUrl = `${MAIN_URL}${this.state.appData.organization.whitelabel_slug}/${this.state.appData.user.agent_url}/${this.state.appData.editslug}`;
        window.open(EditAppUrl, "_blank"); // redirect to edit page
    };

    navigate(event) {
        var message = "";
        var link = "/";
        let editslug = "";
        this.state.preapp.forEach((element) => {
            if (element.id == this.state.check[0]) {
                editslug = element.editslug;
            }
        });
        if (event.target.name == "Copy Application") {
            message = "Are you sure you want to copy the application";
            link += "powerapps/" + this.state.check[0] + "/copy";
        } else if (event.target.name == "Re-run") {
            message = "Are you sure you want to rerun the application's PDF";
            link += "powerapps/" + this.state.check[0] + "/rerun";
        } else if (event.target.name == "ownership") {
            message =
                "Are you sure you want to change the ownership of the preapp";
            link +=
                this.state.user.username + "/" + editslug + "/change/ownership";
        } else if (event.target.name == "cancel") {
            message = "Are you sure you want to cancel the preapp";
            link +=
                this.state.user.username + "/" + editslug + "/archive/confirm";
        } else if (event.target.name == "prevet") {
            message = "Are you sure you want to  navigate to the new prevet";
            link =
                STRATUS_URL +
                "/" +
                this.state.appData.organization.name
                    .replace(/ /g, "")
                    .toLowerCase() +
                "/" +
                this.state.user.name +
                "/" +
                this.state.appData.editslug;
        } else if (event.target.name == "Re-Activate") {
            message = "Are you sure you want to reactivate the pre-app";
            link +=
                this.state.user.username + "/" + editslug + "/archive/revert";
        }
        if (confirm(message)) {
            window.location = link;
        }
    }

    handleOpenModal = () => {
        this.setState({ showModal: true });
    };

    handleCloseModal = () => {
        this.setState({ showModal: false });
    };
    handleUpload() {
        if (this.uploadTitle != "") {
            this.setState({ uploadFileError: null });
            this.TitleArrray.push(this.uploadTitle);
            this.handleCloseModal();
            this.checkUpload();
        }
    }
    checkUpload() {
        if (this.uploads.length != this.TitleArrray.length) {
            let count = this.state.file + 1;
            this.setState({ file: count });
            this.handleOpenModal();
        } else {
            const data = new FormData();
            this.uploads.forEach((file) => {
                data.append("files[]", file, file.name);
            });
            this.TitleArrray.forEach((element) => {
                data.append("title[]", element);
            });

            var app_id =
                this.state.note_app_id != ""
                    ? this.state.note_app_id
                    : this.state.appData.id;
            this.setState({ show_right_spinner: true });
            Uploads(app_id, data)
                .then((response) => {
                    if (response.status) {
                        this.getAppFiles("show_right_spinner");
                        this.setState({
                            show_right_spinner: false,
                            uploadFileError: null,
                        });
                    } else {
                        this.setState({
                            show_right_spinner: false,
                            uploadFileError: response.message,
                        });
                        this.refreshUploadError();
                    }
                })
                .catch((error) => {
                    let errorMessage =
                        error.status === 413
                            ? "File Is Too Large. Please try again"
                            : "Something went wrong. Please try again";
                    this.setState({
                        show_right_spinner: false,
                        uploadFileError: errorMessage,
                    });
                    this.refreshUploadError();
                });
            this.TitleArrray = [];
        }
    }

    refreshUploadError() {
        setTimeout(() => {
            this.setState({ uploadFileError: null });
        }, 3000);
    }

    handleCheckBox = (event) => {
        if (event.target.checked) {
            this.state.check.push(event.target.value);
        } else {
            if (this.state.check.includes(event.target.value)) {
                this.state.check.splice(
                    this.state.check.indexOf(event.target.value),
                    1,
                );
            }
        }
    };

    handleStar(app) {
        var data = {};
        if (app != undefined) {
            data.id = app[1].id;
            data.is_stared = event.target.checked ? 1 : 0;
            starApp(data)
                .then((response) => {
                    if (response.status) {
                        let change = this.state.preapp;
                        change[app[0]].stared = data.is_stared
                            ? response.data
                            : null;
                        this.setState(change);
                    }
                })
                .catch((error) => {});
        }
    }

    logout() {
        Logout()
            .then((response) => {
                window.location = "/";
            })
            .catch((error) => {});
    }

    handleTab(eventkey) {
        let change = {};
        change.tab = eventkey.target.name;
        this.setState(change);
    }
    handleMenu() {
        if (this.state.filterToggle) {
            this.setState({ filterToggle: false });
        } else {
            this.setState({ filterToggle: true });
        }
    }
    handleMenu() {}
    searchPreapp = (event) => {
        this.setState({
            search: event.target.value,
        });
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
            this.getPreappData();
        }, 500);
    };

    handleNote(event) {
        let change = {};
        change.note = event.target.value;
        change.noteErrorMessage = "";
        this.setState(change);
    }

    submit(event) {
        if (this.state.note != "") {
            let NoteData = {};
            NoteData["add-agentnote"] =
                event.target.name == "agent" ? "agent_note" : "";
            NoteData["add-pcinote"] =
                event.target.name == "pci" ? "add-pcinote" : "";
            NoteData["content"] = this.state.note;
            NoteData["stratus"] = true;
            this.setState({
                note: "",
            });
            if (event.target.name == "agent") {
                this.setState({
                    agent_text: "Sending...",
                });
            } else {
                this.setState({
                    pci_text: "Sending...",
                });
            }
            var app_id =
                this.state.note_app_id != ""
                    ? this.state.note_app_id
                    : this.state.appData.id;
            addNotes(app_id, NoteData)
                .then((response) => {
                    this.setState({
                        agent_text: "Send Agent Note",
                        pci_text: "Send PCI Note",
                    });
                    this.getAppNotes();
                    if (NoteData["add-agentnote"] != "") {
                        if (
                            this.state.preapp[this.state.appkey].important !=
                            null
                        ) {
                            this.state.preapp[this.state.appkey].important =
                                response.important.data;
                            this.state.important.forEach((value, index) => {
                                if (value.id == this.state.appData.id) {
                                    this.state.important[index].important =
                                        response.important.data;
                                }
                            });
                        } else {
                            this.state.preapp[this.state.appkey].important =
                                response.important.data;
                        }
                    }
                })
                .catch((error) => {
                    if (error.status === 422) {
                        if (error.data && error.data.message) {
                            this.setState({
                                noteErrorMessage: error.data.message,
                            });
                        }
                    }
                    this.setState({
                        agent_text: "Send Agent Note",
                        pci_text: "Send PCI Note",
                    });

                    setTimeout(() => {
                        this.setState({ noteErrorMessage: "" });
                    }, 5000);
                });
        }
    }

    openDrawer() {
        this.setState({ todo: true });
    }

    closeDrawer() {
        this.setState({ todo: false, add_todo: false });
    }

    addTasks() {
        this.setState({ add_todo: true });
    }
    todoChange(e) {
        let change = {};
        change.todo_text = event.target.value;
        this.setState(change);
    }
    todoSubmit() {
        let data = {};
        data.text = this.state.todo_text;
        addTodo(data)
            .then((response) => {
                this.getTodoList();
                this.setState({ todo_text: "" });
            })
            .catch((error) => {});
    }

    editTodo(id) {
        this.setState({ todo_id: id });
    }
    handleTodo(e, index) {
        let change = {};
        this.state.todo_list[index].text = event.target.value;
        this.setState(change);
    }

    todoUpdate(e, element) {
        updateTodo(element)
            .then((response) => {
                this.getTodoList();
                this.setState({ todo_id: "" });
            })
            .catch((error) => {});
    }

    removeTodo(id) {
        deleteTodo(id)
            .then((response) => {
                this.getTodoList();
                this.setState({ todo_id: "" });
            })
            .catch((error) => {});
    }
    completeTodo(e, data) {
        data.is_completed = event.target.checked ? "yes" : "no";
        updateTodo(data)
            .then((response) => {
                this.getTodoList();
                this.setState({ todo_id: "" });
            })
            .catch((error) => {});
    }
    handleFilterMenu() {
        let change = {};
        change.FilterMenu = this.state.FilterMenu ? false : true;
        this.setState(change);
    }

    changeFilter(e) {
        this.state.filterBy = event.target.name == "incompleted" ? "no" : "yes";
        this.setState({ FilterMenu: false });
        this.getTodoList();
    }

    fetchMoreData = () => {
        this.setState(
            {
                page: this.state.page + 1,
            },
            function () {
                this.getPreappData(false);
            },
        );
    };

    sortData(SortBy) {
        let SortValue = this.state.sortValue;
        if (this.state.sortBy == SortBy) {
            SortValue = SortValue == "DESC" ? "ASC" : "DESC";
        } else {
            SortValue = "ASC";
        }
        this.setState(
            {
                sortBy: SortBy,
                sortValue: SortValue,
            },
            function () {
                this.getPreappData();
            },
        );
    }
    showSearch(e) {
        e.stopPropagation();
        this.setState({ showFilters: !this.state.showFilters });
    }
    hideSearch() {
        this.setState({ showFilters: false });
    }
    updateImportantTag(data, key, isImportant) {
        updateImportant(data.important.id)
            .then((response) => {
                if (response.status) {
                    if (isImportant != null) {
                        this.state.important[key].important.is_important = 0;
                        this.setState({ update: true, update_id: data.id });
                    } else {
                        this.state.preapp[key].important.is_important = 0;
                    }
                }
            })
            .catch((error) => {});
    }
    updateList() {
        if (
            this.state.update_id != this.state.appData.id &&
            this.state.update
        ) {
            this.state.important_id.splice(
                this.state.important_id.indexOf(this.state.update_id),
                1,
            );
            this.getPreappData();
        }
    }
    handleProgression() {
        this.setState({
            new_progression: event.target.value,
            confirm: true,
            resend_sign: "status",
            confirmText: "Are you sure you want to change the status?",
        });
    }
    handleClose() {
        this.setState({
            confirm: false,
            resend_sign: false,
            show_banks: false,
        });
    }
    progressionChanged() {
        if (this.state.resend_sign == "sign") {
            let data = {};
            data.id = this.state.appData.id;
            data.stratus = true;
            resendSignature(data)
                .then((response) => {
                    if (response.status) {
                        this.setState({ confirm: false, resend_sign: false });
                    }
                })
                .catch((error) => {});
        } else if (this.state.resend_sign == "status") {
            let data = {};
            data.id = this.state.appData.id;
            data.progression_id = this.state.new_progression;
            updateProgression(data)
                .then((response) => {
                    if (response.status) {
                        this.getAppData();
                        this.getPreappData();
                        this.setState({ confirm: false });
                    }
                })
                .catch((error) => {});
        } else if (this.state.resend_sign == "rerun") {
            this.handleRerun();
        } else if (this.state.resend_sign == "sign_request") {
            this.submitSign();
        } else if (this.state.resend_sign == "confirm-sign") {
            this.submitConfirm();
        } else if (this.state.resend_sign == "revive-application") {
            this.submitRevive();
        } else if (this.state.resend_sign == "cancel-app") {
            this.submitCancel();
        } else if (this.state.resend_sign == "cancel-sign") {
            this.cancelSign();
        } else if (this.state.resend_sign == "copy-app") {
            this.handleCopyApp();
        }
    }
    handleProgressionFilter = (val) => {
        let ids = [];
        if (val.length >= 1) {
            val.forEach((element) => {
                ids.push(element.value);
            });
        }
        this.setState({
            selected_progression: ids,
        });
    };
    handleRelationManager = (val) => {
        let manager_ids = [];
        if (val.length >= 1) {
            val.forEach((element) => {
                manager_ids.push(element.value);
            });
        }
        this.setState({
            selected_manager: manager_ids,
        });
    };
    clearSearch = () => {
        this.setState(
            {
                search: "",
            },
            function () {
                this.getPreappData();
            },
        );
    };

    toggleSearch = () => {
        this.setState({
            searchInputShow: true,
        });
    };

    resentSignature() {
        this.setState({
            confirm: true,
            resend_sign: "sign",
            confirmText: "Are you sure you want to resend signature?",
        });
    }
    getAppFiles(spinner) {
        let data = {};
        data.id =
            this.state.note_app_id != ""
                ? this.state.note_app_id
                : this.state.appData.id;
        data.parent_id = this.state.parent_id;
        const spinner_name = spinner ? spinner : "show_spinner";
        this.setState({ [spinner_name]: true });
        getFiles(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;
                    change.files = response.files;
                    change.uploads = response.uploads;
                    this.setState(change);
                    this.setState({ [spinner_name]: false });
                }
            })
            .catch((error) => {
                this.setState({ [spinner_name]: false });
            });
    }

    deleteUploadedFiles = (upload_id, spinner) => {
        if (confirm("Are you sure you want to delete this file?")) {
            let data = {};
            data.id =
                this.state.note_app_id != ""
                    ? this.state.note_app_id
                    : this.state.appData.id;
            data.upload_id = upload_id;
            const spinner_name = spinner ? spinner : "show_spinner";
            this.setState({ [spinner_name]: true });
            DeleteFile(data)
                .then((response) => {
                    if (response.success) {
                        this.setState({ [spinner_name]: true });
                        this.getAppFiles(spinner);
                    } else {
                        alert("Error while deleting file");
                    }
                })
                .catch((error) => {
                    this.setState({ [spinner_name]: false });
                });
        }
    };

    getAppInfo() {
        let data = {};
        data.id = this.state.appData.id;
        getMerchantInfo(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;

                    change.creditcardprocess = response.creditcardprocess;
                    change.bankinfo = response.bankinfo;
                    change.powerappequipment = response.powerappequipment;
                    change.powerappbusinessprofile =
                        response.powerappbusinessprofile;
                    change.prices = response.prices;

                    this.setState(change);
                    this.getBankList();
                }
            })
            .catch((error) => {});
    }

    bankChange() {
        this.setState({ show_banks: false, selected_bank: "" });
        this.getPreappData();
        this.getBankList();
    }

    showBanks = () => {
        this.setState({ show_banks: true });
    };

    handleActiveBank(element) {
        const patent_id =
            element.id != undefined ? element.parent_id : this.state.activeId;
        const note_app_id =
            element.id != undefined ? element.id : this.state.activeId;
        this.setState(
            {
                activeBank:
                    element.bank != undefined ? element.bank.id : default_bank,
                bank_name: element.bank != undefined ? element.bank.name : "",
                tab: "tab2",
                is_parent: false,
                parent_id: patent_id,
                note_app_id: note_app_id,
            },
            function () {
                this.getAppData();
            },
        );
    }

    deleteNote = (id) => {
        if (confirm("Are you sure you want to delete this note?")) {
            deleteNote(id)
                .then((response) => {
                    if (response.success) {
                        this.getAppNotes();
                    } else {
                    }
                })
                .catch((error) => {});
        }
    };

    getAppNotes = () => {
        let data = {};
        data.id = Number.isInteger(this.state.note_app_id)
            ? this.state.note_app_id
            : this.state.appData.id;
        data.parent_id =
            this.state.activeBank == default_bank
                ? default_bank
                : this.state.parent_id;
        getNotes(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;

                    change.latest = response.latest;
                    change.notes = response.notes;
                    change.ehawk = response.ehawk;
                    change.system_notes = response.system_notes;
                    this.setState(change);
                }
            })
            .catch((error) => {});
    };
    getBankList() {
        let data = {};
        data.id = this.state.activeId;
        bankList(data)
            .then((response) => {
                let bankNameOfselectedPreap = "";
                if (response.status) {
                    this.setState({ banks: response.bank_list });
                    const selectedAppBankID =
                        this.state.appData && this.state.appData.bank_id
                            ? this.state.appData.bank_id
                            : undefined;
                    if (selectedAppBankID) {
                        const bankInfo = response.bank_list.find(
                            (x) => x.value === parseInt(selectedAppBankID),
                        );
                        if (bankInfo) {
                            bankNameOfselectedPreap = bankInfo.label;
                        } else {
                            bankNameOfselectedPreap = "Default";
                        }
                    } else {
                        bankNameOfselectedPreap = "Default";
                    }
                }
                this.setState({ selectedAppBankName: bankNameOfselectedPreap });
            })
            .catch((error) => {});
    }
    handlePdfRun(id) {
        this.setState({
            bank_id: id,
            confirm: true,
            resend_sign: "rerun",
            confirmText:
                "Are you sure you want to re-run the application's PDF?",
        });
    }
    handleRerun() {
        let data = {};
        data.id = this.state.bank_id ? this.state.bank_id : this.state.activeId;
        data.stratus = true;
        runPdf(data)
            .then((response) => {
                this.setState({
                    bank_id: "",
                    confirm: false,
                    resend_sign: "",
                    confirmText: "",
                });
            })
            .catch((error) =>
                this.setState({
                    bank_id: "",
                    confirm: false,
                    resend_sign: "",
                    confirmText: "",
                }),
            );
    }

    handleAppCopy(id) {
        this.setState({
            appId: id,
            confirm: true,
            resend_sign: "copy-app",
            confirmText: "Are you sure you want to copy the application?",
        });
    }

    handleCopyApp() {
        let data = {};
        data.id = this.state.appId;
        data.stratus = true;
        data.ajaxRequest = true;
        this.setState({ showLoader: true });
        copyApp(data)
            .then((response) => {
                if (response.status) {
                    this.setState({ showLoader: false });
                    let url_name = this.getUrlName();
                    window.location = `${MAIN_URL}${
                        this.state.appData.organization.whitelabel_slug
                    }/${this.state.appData.user.agent_url}/${response.data}`;
                }
            })
            .catch((error) => {});
    }

    handleToggleAccordion(accordionNumber) {
        if (accordionNumber === this.state.accordionNumber) {
            setTimeout(() => {
                this.setState({
                    accordionNumber: -1,
                });
            }, 300);
        } else {
            this.setState({
                accordionNumber: accordionNumber,
            });
        }
    }

    sendSign() {
        this.setState({
            confirm: true,
            resend_sign: "sign_request",
            confirmText:
                "Are you sure you want to send the application's for signature?",
        });
    }

    submitSign() {
        let data = {};
        data.id = this.state.appData.id;
        data.stratus = true;
        sendSignature(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;
                    change.progression_id = awaiting_signature;
                    var new_progression = this.state.preapp;
                    new_progression[this.state.appkey].progression_id =
                        awaiting_signature;
                    new_progression[this.state.appkey].progression.status =
                        "Awaiting Signature";
                    this.setState([change, new_progression]);
                    this.setState({
                        bank_id: "",
                        confirm: false,
                        resend_sign: "",
                        confirmText: "",
                    });
                }
            })
            .catch((error) => {});
    }

    handleApprove() {
        this.setState({
            confirm: true,
            resend_sign: "confirm-sign",
            confirmText: "Are you sure you want to Approve and send e-sign ?",
        });
    }
    submitRevive() {
        let data = {};
        data.id = this.state.activeId;
        reviveApplication(data).then((response) => {
            this.setState({
                confirm: false,
            });
        });
    }
    submitConfirm() {
        let data = {};
        data.id = this.state.appData.id;
        data.stratus = true;
        resendSignature(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;
                    change.progression_id = awaiting_signature;
                    var new_progression = this.state.preapp;
                    new_progression[this.state.appkey].progression_id =
                        awaiting_signature;
                    new_progression[this.state.appkey].progression.status =
                        "Awaiting Signature";
                    this.setState([change, new_progression]);
                    this.setState({
                        bank_id: "",
                        confirm: false,
                        resend_sign: "",
                        confirmText: "",
                    });
                    this.setState({ confirm: false, resend_sign: false });
                }
            })
            .catch((error) => {});
    }

    handleCancle() {
        this.setState({
            confirm: true,
            resend_sign: "cancel-app",
            confirmText: "Are you sure you want Cancel Application ?",
        });
    }
    handleReviveApplication() {
        this.setState({
            confirm: true,
            resend_sign: "revive-application",
            confirmText:
                "Are you sure you want to revive this cancelled application ?",
        });
    }
    handleCancelSign() {
        this.setState({
            confirm: true,
            resend_sign: "cancel-sign",
            confirmText:
                " Canceling signature process will reset everything and return you to the Pricing stage. Are you sure you want Cancel signature ?",
        });
    }

    submitCancel() {
        let data = {};
        data.id = this.state.appData.id;
        data.stratus = true;
        cancelApp(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;
                    change.progression_id = response.data.progression_id;
                    var new_progression = this.state.preapp;
                    new_progression[this.state.appkey].progression_id =
                        response.data.progression_id;
                    new_progression[this.state.appkey].progression.status =
                        "Cancelled";
                    this.setState([change, new_progression]);
                    this.setState(
                        {
                            bank_id: "",
                            confirm: false,
                            resend_sign: "",
                            confirmText: "",
                        },
                        () => {
                            this.getAppData();
                        },
                    );
                }
            })
            .catch((error) => {});
    }
    cancelSign() {
        let data = {};
        data.id = this.state.appData.id;
        data.stratus = true;
        cancelSignature(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;
                    change.progression_id = response.data.progression_id;
                    var new_progression = this.state.preapp;
                    new_progression[this.state.appkey].progression_id =
                        response.data.progression_id;
                    new_progression[this.state.appkey].progression.status =
                        "Awaiting Pricing";
                    this.setState([change, new_progression]);
                    this.setState({
                        bank_id: "",
                        confirm: false,
                        resend_sign: "",
                        confirmText: "",
                    });
                }
            })
            .catch((error) => {});
    }

    getScoreClass(data) {
        const score = data && data.score ? data.score : null;
        if (score != null) {
            if (score.total > 0) {
                return "ehawk-success";
            } else if (score.total === 0) {
                return "ehawk-primary";
            } else if (score.total < 0) {
                return "ehawk-danger";
            }
        } else {
            return "";
        }
    }

    resetDetailsAccordion() {
        this.setState({
            accordionNumber: 0,
        });
    }

    getUrlName() {
        let url_name = "";

        if (this.state.appData.user) {
            const name_arr = this.state.appData.user.name.split(" ");

            if (name_arr.length >= 2) {
                if (name_arr.length == 2) {
                    const agent = name_arr[0].charAt(0);
                    const lastname = name_arr.length > 1 ? name_arr[1] : "";
                    url_name = agent + lastname;
                }

                if (name_arr.length == 3) {
                    const agent = name_arr[0].charAt(0);
                    const lastname = name_arr.length > 1 ? name_arr[2] : "";
                    url_name = agent + lastname;
                }
            }
        }

        return url_name;
    }

    onExportCSVModalCloseHandler = () => {
        this.setState({ showExportCSVModal: false });
    };

    onExportCSVModalOpenHandler = () => {
        this.setState({ showExportCSVModal: true });
    };

    onExportCSVButtonClickHandler = (exportSize) => {
        this.setState({ showExportSpinner: true });
        var query = {
            left_progression_filter: "active",
            search: this.state.search || "",
            sortBy: this.state.sortBy || "",
            sortValue: this.state.sortValue || "",
            manager_id: this.state.selected_manager || [],
            progression_id: this.state.selected_progression || [],
            page: this.state.page,
            exportSize: exportSize,
        };

        getExportCSVLink(query).then((response) => {
            fileDownload(response.data, "report.csv");
            this.setState({ showExportSpinner: false });
        });
    };
    PricingLabel = (type) => {
        switch (type) {
            case "icppt":
                return "IC Plus / Pass-Through";
                break;
            case "tiered":
                return "Tiered";
                break;
            case "sccd":
                return "Surcharge / Cash Discount";
                break;
            default:
                return "";
                break;
        }
    };
    currentProgressName = (progressionId) => {
        if (this.state.loggedInUser?.channel == "sales_channel") {
            if (progressionId < 5) {
                return "Working Lead";
            }
            if (progressionId > 4 && progressionId < 10) {
                return "App in Progress";
            }
            if (progressionId > 9 && progressionId < 14) {
                return "Unworkable";
            }
            if (progressionId > 13 && progressionId < 17) {
                return "Underwriting";
            }
            if (progressionId > 16 && progressionId < 21) {
                return "Approved";
            }
            if (progressionId > 20 && progressionId < 23) {
                return "Declined";
            }
            return "";
        } else {
            switch (progressionId) {
                case 0:
                    return "Awaiting Preapp";
                case 1:
                    return "Awaiting Preapp";
                case 2:
                    return "Awaiting Business Profile";
                case 3:
                    return "Awaiting Pricing";
                case 4:
                    return "Awaiting Pricing Confirmation";
                case 5:
                    return "Awaiting For Equipments";
                case 6:
                    return "Awaiting Signature Request";
                case 7:
                    return "Awaiting Signature";
                case 8:
                    return "Pre-Bank Review";
                case 9:
                    return "Underwriting Review";
                case 10:
                    return "Pended";
                case 11:
                    return "Awaiting Reserve";
                case 12:
                    return "Approved";
                case 13:
                    return "Denied";
                case 14:
                    return "Cancelled";
                case 15:
                    return "App pending PC approval";
                case 16:
                    return "Sent for Signature";
                case 17:
                    return "PDF requested";
                case 18:
                    return "Awaiting wet signature";
                case 19:
                    return "Pending Prevet";
                case 20:
                    return "Prevet Approved";
                case 21:
                    return "Terminated";
                case 22:
                    return "Support";
            }
        }
        return "";
    };
    render() {
        const {
            preapp,
            appData,
            user,
            file,
            check,
            action,
            tab,
            detailsAccordion,
            mobileMenu,
            activeId,
            organization_user,
            todo,
            add_todo,
            todo_list,
            todo_id,
            FilterMenu,
            filterBy,
            hasMore,
            sortBy,
            sortValue,
            pci_admin,
            showFilters,
            important,
            important_id,
            relationManager,
            selected_manager,
            progression_data,
            selected_progression,
            resend_sign,
            show_info,
            row_info,
            banks,
            selected_bank,
            defaultBank,
            activeBank,
            bank_name,
            confirmText,
            is_parent,
            header_user_name,
            showButtons,
            accordionNumber,
            show_spinner,
            totalCount,
            loggedInUser,
            show_right_spinner,
            filterToggle,
            showLoader,
            uploadFileTypeError,
            user_options,
            organization_options,
            owner_selected_organization,
            selected_owner,
            left_progression_filter,
            showAlert,
            alertHeader,
            alertMessage,
            selectedAppBankName,
        } = this.state;
        let url_name = "";
        let button_name = "";
        url_name = this.getUrlName();

        const isMobile = this.state.windowWidth <= MOBILE_SCREEN_WIDTH;

        // convert progression id into percentage
        const status2Percentage = (preapp) => {
            return this.currentStatus(preapp.progression_id)[1];
        };
        const currentStatus = (preapp) => {
            return this.currentStatus(preapp.progression_id)[0];
        };

        // get bank label for column
        const getBankLabel = (preapp) => {
            if (preapp.child.length > 0) {
                return (
                    <span className="has-more">{preapp.child.length + 1}</span>
                );
            }
            return defaultBank.name;
        };
        const ProgressionName = (appData) => {
            switch (appData.progression_id) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    return "Continue Application";
                case 6:
                case 7:
                    return "Continue Application";
                case 6:
                    return "Continue Application";

                default:
                    return "Continue Application";
            }
        };

        const bindUserName = (user_id) => {
            if (organization_user && organization_user.length > 0) {
            } else {
            }
        };

        const appInfoContent = isMobile ? (
            <div className="mobile-app-info">
                <div className="mobile-app-info-header">
                    <h2>App ID: {appData.id}</h2>&nbsp;
                    <span className="separator">|</span>&nbsp;
                    {appData.progression_id <= 7 ? (
                        <>
                            <p>
                                {this.CurrentProgressionName(
                                    appData.progression_id,
                                )}
                            </p>
                            <StatusBar
                                percentage={status2Percentage(appData)}
                            />
                        </>
                    ) : (
                        <StatusRightContent
                            t={appData}
                            status={this.CurrentProgressionName(
                                appData.progression_id,
                            )}
                        />
                    )}
                </div>
                <div className="app-info">
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            borderBottom: "#EAEBEF 1px solid",
                        }}
                    >
                        <div className="organization-test">
                            <div className="second-column">
                                <div className="organization">
                                    <div className="avatar">
                                        <img
                                            src={
                                                appData.organization
                                                    ? "/img/" +
                                                      appData.organization
                                                          .whitelabel_slug +
                                                      "/logo-trans.png"
                                                    : ""
                                            }
                                        />
                                    </div>
                                    <div className="organization-details">
                                        <p>
                                            {appData.organization ? (
                                                <Link
                                                    to={
                                                        "/organization/" +
                                                        appData.organization.id
                                                    }
                                                >
                                                    {appData.organization.name}
                                                </Link>
                                            ) : (
                                                <>&mdash;</>
                                            )}
                                            <br />
                                            <span>Organization</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="organization_9">
                            <div className="organization">
                                <div className="organization-details">
                                    <p>
                                        {appData.user ? (
                                            appData.user.name
                                        ) : (
                                            <>&mdash;</>
                                        )}
                                        <br />
                                        <span>Agent</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            marginTop: "2rem",
                        }}
                    >
                        <div
                            className="organization_10"
                            style={{ width: "50%" }}
                        >
                            <div className="organization">
                                <div className="organization-details">
                                    <p>
                                        {appData.field_dba || <>&mdash;</>}
                                        <br />
                                        <span>Merchant DBA</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            className="organization_10"
                            style={{ width: "50%" }}
                        >
                            <div className="organization">
                                <div className="organization-details">
                                    <p>
                                        {appData.field_legalname || (
                                            <>&mdash;</>
                                        )}
                                        <br />
                                        <span>Merchant Legal</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            className="organization_10"
                            style={{ width: "50%" }}
                        >
                            <div className="organization">
                                <div className="organization-details">
                                    <p>
                                        {selectedAppBankName !== "" ? (
                                            selectedAppBankName
                                        ) : (
                                            <>&mdash;</>
                                        )}
                                        <br />
                                        <span>Processors Name</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div className="app-info">
                <div className="row app-info-row1">
                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                        <div className="first-column">
                            <h2>App ID: {appData.id}</h2>

                            {appData.progression_id <= 7 ? (
                                <>
                                    <p>
                                        {this.CurrentProgressionName(
                                            appData.progression_id,
                                        )}
                                    </p>
                                    <StatusBar
                                        percentage={status2Percentage(appData)}
                                    />
                                </>
                            ) : (
                                <StatusRightContent
                                    t={appData}
                                    status={this.CurrentProgressionName(
                                        appData.progression_id,
                                    )}
                                />
                            )}
                            <div>
                                {pci_admin ? (
                                    <div>
                                        <div>
                                            {appData.zoho_id &&
                                            !appData.zoho_submission_id ? (
                                                <a
                                                    className="zoho_link"
                                                    target="_blank"
                                                    href={`https://crm.zoho.com/crm/org49631815/tab/Leads/${appData.zoho_id}`}
                                                >
                                                    LEAD
                                                </a>
                                            ) : null}
                                        </div>
                                        <div>
                                            {appData.zoho_id &&
                                            appData.zoho_submission_id ? (
                                                <a
                                                    className="zoho_link"
                                                    target="_blank"
                                                    href={`https://crm.zoho.com/crm/org49631815/tab/Potentials/${appData.zoho_submission_id}`}
                                                >
                                                    Submission
                                                </a>
                                            ) : null}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 chart">
                        <div className="second-column">
                            <div className="organization">
                                <div className="organization-details">
                                    <p>
                                        <Link to="" className="" type="button">
                                            {appData.organization ? (
                                                <Link
                                                    to={
                                                        "/organization/" +
                                                        appData.organization.id
                                                    }
                                                >
                                                    {appData.organization.name}
                                                </Link>
                                            ) : (
                                                <>&mdash;</>
                                            )}
                                        </Link>

                                        <br />
                                        <span>Organization</span>
                                    </p>
                                    <p>
                                        {appData.user ? (
                                            appData.user.name
                                        ) : (
                                            <>&mdash;</>
                                        )}
                                        <br />
                                        <span>Agent</span>
                                    </p>
                                    <p>
                                        {appData.primary_contact_user ? (
                                            appData.primary_contact_user
                                        ) : (
                                            <>&mdash;</>
                                        )}
                                        <br />
                                        <span>TL</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 org-info">
                        <div className="third-column">
                            <div className="organization-details">
                                <p>
                                    {appData.field_dba || <>&mdash;</>}
                                    <br />
                                    <span>Merchant DBA</span>
                                </p>
                                <p>
                                    {appData.field_legalname || <>&mdash;</>}
                                    <br />
                                    <span>Merchant Legal</span>
                                </p>
                                <p>
                                    {selectedAppBankName !== "" ? (
                                        selectedAppBankName
                                    ) : (
                                        <>&mdash;</>
                                    )}
                                    <br />
                                    <span>Processors Name</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row app-info-row2 no-gutters">
                    <div className="col-lg-12">
                        <div className="review-application">
                            {appData.organization &&
                            appData.user &&
                            appData.progression_id <= 7 ? (
                                <a
                                    className="btn btn-default btn-sm btn-outline-primary"
                                    target="_blank"
                                    href={`${MAIN_URL}${
                                        appData.organization.whitelabel_slug
                                    }/${appData.user.agent_url}/${appData.editslug}`}
                                >
                                    {appData.progression_id < 6 ? (
                                        <span>Continue Application</span>
                                    ) : (
                                        <span>Edit Application</span>
                                    )}
                                </a>
                            ) : null}
                            {appData.organization && appData.user ? (
                                <>
                                    {this.state.showSendLinkModal ? (
                                        <SendLinkMerchant
                                            showSendLinkModal={
                                                this.state.showSendLinkModal
                                            }
                                            toggleSendLinkModal={
                                                this.toggleSendLinkModal
                                            }
                                            link={`${MAIN_URL}${
                                                appData.organization
                                                    .whitelabel_slug
                                            }/${appData.user.agent_url}/${appData.editslug}`}
                                            editSlug={appData.editslug}
                                        />
                                    ) : null}
                                    <button
                                        className="btn btn-default btn-sm btn-outline-primary"
                                        onClick={() =>
                                            this.toggleSendLinkModal(true)
                                        }
                                    >
                                        Send Link To Merchant
                                    </button>
                                </>
                            ) : null}

                            {appData.progression_id ==
                                awaiting_signature_request && (
                                <a
                                    className="btn btn-default btn-sm btn-outline-primary"
                                    target="_blank"
                                    href={`${MAIN_URL}${
                                        appData.organization.whitelabel_slug
                                    }/${appData.user.agent_url}/${appData.editslug}`}
                                >
                                    Send for signature
                                </a>
                            )}

                            {appData.id &&
                                signature_ids.includes(
                                    appData.progression_id,
                                ) && (
                                    <a
                                        className="btn btn-default btn-sm btn-outline-primary"
                                        onClick={(e) => this.resentSignature(e)}
                                    >
                                        Re-send for signature
                                    </a>
                                )}
                            {appData.id &&
                                signature_ids.includes(
                                    appData.progression_id,
                                ) && (
                                    <a
                                        className="btn btn-default btn-sm btn-outline-primary"
                                        onClick={(e) =>
                                            this.handleCancelSign(e)
                                        }
                                    >
                                        Cancel signature
                                    </a>
                                )}
                            {appData.id &&
                                appData.progression_id ==
                                    Cancelled_Application && (
                                    <a
                                        className="btn btn-default btn-sm btn-outline-primary"
                                        onClick={(e) =>
                                            this.handleReviveApplication(e)
                                        }
                                    >
                                        Revive Application
                                    </a>
                                )}
                            {pci_admin &&
                                appData.progression_id > 7 &&
                                !hide_progression.includes(
                                    appData.progression_id,
                                ) && (
                                    <form className="progression">
                                        <select
                                            className="form-control"
                                            value={appData.progression_id}
                                            onChange={(e) =>
                                                this.handleProgression()
                                            }
                                        >
                                            {progression_data.map(
                                                (value, k) => (
                                                    <option
                                                        value={value.value}
                                                        key={value.value}
                                                    >
                                                        {value.label}
                                                    </option>
                                                ),
                                            )}
                                        </select>
                                    </form>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        );

        const leftContent = (
            <div className="content-area-left-col">
                <div className="content-area-left">
                    {isMobile ? (
                        <div className="mobile-content-area-left-header">
                            <div className="mobile-header-1">
                                <div className="mobile-header-title">
                                    <h1>
                                        All Merchants{" "}
                                        <span>({totalCount})</span>
                                    </h1>
                                </div>
                                <div className="mobile-header-search">
                                    <form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            this.getPreappData();
                                        }}
                                    >
                                        <input
                                            type="text"
                                            value={this.state.search}
                                            placeholder="Search"
                                            name="search"
                                            className={
                                                this.state.searchInputShow
                                                    ? ""
                                                    : "search-box"
                                            }
                                            onChange={this.searchPreapp}
                                        />
                                        <button type="submit">
                                            <i
                                                className="fa fa-search"
                                                onClick={this.toggleSearch}
                                            ></i>
                                        </button>
                                        {this.state.search && (
                                            <a
                                                className="searchbar-close"
                                                onClick={this.clearSearch}
                                            >
                                                <i className="fa fa-close"></i>
                                            </a>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="content-area-left-header">
                            <div className="header-title">
                                <h1>All Merchants </h1>
                            </div>
                            <div className="header-search">
                                <i
                                    className="fa fa-download pointer"
                                    style={{ marginRight: "1.5em" }}
                                    onClick={this.onExportCSVModalOpenHandler}
                                />
                                {this.state.showExportCSVModal ? (
                                    <ExportCSVModal
                                        onExportCSVButtonClickHandler={
                                            this.onExportCSVButtonClickHandler
                                        }
                                        show={this.state.showExportCSVModal}
                                        handleClose={
                                            this.onExportCSVModalCloseHandler
                                        }
                                        showExportSpinner={
                                            this.state.showExportSpinner
                                        }
                                    />
                                ) : null}
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        this.getPreappData();
                                    }}
                                >
                                    <input
                                        type="text"
                                        value={this.state.search}
                                        placeholder="Search"
                                        name="search"
                                        className="search-box"
                                        onChange={this.searchPreapp}
                                    />
                                    <button type="submit">
                                        <i className="fa fa-search"></i>
                                    </button>
                                    {this.state.search && (
                                        <a
                                            className="searchbar-close"
                                            onClick={this.clearSearch}
                                        >
                                            <i className="fa fa-close"></i>
                                        </a>
                                    )}
                                </form>
                            </div>
                        </div>
                    )}

                    <form>
                        {loggedInUser && loggedInUser.role && (
                            <div id="scrollableDiv">
                                <div className="table-div merchant">
                                    <div className="table-div-thead">
                                        <div
                                            className={
                                                loggedInUser.role !== "agent"
                                                    ? "table-div-th col-merchant-dba col-merchant-newdba"
                                                    : "table-div-th col-merchant-dba dba-name-agent col-merchant-newdba"
                                            }
                                            onClick={(e) =>
                                                this.sortData("field_dba")
                                            }
                                        >
                                            DBA{" "}
                                            {sortBy === "field_dba" && (
                                                <i
                                                    className={
                                                        sortValue === "ASC"
                                                            ? "fa fa-arrow-up"
                                                            : "fa fa-arrow-down"
                                                    }
                                                    aria-hidden="true"
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="table-div-tbody">
                                        <InfiniteScroll
                                            dataLength={preapp.length || 1}
                                            next={this.fetchMoreData}
                                            hasMore={hasMore}
                                            loader={
                                                <div className="loaderWrap">
                                                    <p className="loader">
                                                        {hasMore
                                                            ? "Loading..."
                                                            : "no more data"}
                                                    </p>
                                                </div>
                                            }
                                            height="100%"
                                        >
                                            {Object.entries(important).map(
                                                (t, k) =>
                                                    important_id.includes(
                                                        t[1].id,
                                                    ) && (
                                                        <div
                                                            className={
                                                                check.includes(
                                                                    "" +
                                                                        t[1]
                                                                            .id +
                                                                        "",
                                                                ) ||
                                                                activeId ===
                                                                    t[1].id
                                                                    ? "table-div-tr active "
                                                                    : "table-div-tr"
                                                            }
                                                            key={t[0]}
                                                            onClick={(e) =>
                                                                this.handleClick(
                                                                    t[1].id,
                                                                    t[0],
                                                                )
                                                            }
                                                            onMouseLeave={() => {
                                                                this.handleHideButtons();
                                                            }}
                                                            onMouseEnter={() => {
                                                                this.handleShowButtons();
                                                            }}
                                                        >
                                                            <div className="table-div-td col-merchant-dba">
                                                                {t[1]
                                                                    .field_dba || (
                                                                    <>&mdash;</>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ),
                                            )}
                                            {important.length >= 1 && (
                                                <div className="table-div-tr seprator" />
                                            )}

                                            {Object.entries(preapp).map(
                                                (t, k) =>
                                                    !important_id.includes(
                                                        t[1].id,
                                                    ) && (
                                                        <PreappArow
                                                            pci_admin={
                                                                pci_admin
                                                            }
                                                            t={t}
                                                            default_index={
                                                                default_index
                                                            }
                                                            defaultBank={
                                                                defaultBank
                                                            }
                                                            status2Percentage={status2Percentage(
                                                                t[1],
                                                            )}
                                                            handleClick={(
                                                                id,
                                                                data,
                                                            ) =>
                                                                this.handleClick(
                                                                    id,
                                                                    data,
                                                                )
                                                            }
                                                            handleClickWithChild={(
                                                                id,
                                                                data,
                                                            ) =>
                                                                this.handleClickWithChild(
                                                                    id,
                                                                    data,
                                                                )
                                                            }
                                                            handleChildAppClick={(
                                                                id,
                                                                data,
                                                            ) =>
                                                                this.handleChildAppClick(
                                                                    id,
                                                                    data,
                                                                )
                                                            }
                                                            currentStatus={currentStatus(
                                                                t[1],
                                                            )}
                                                            handleStar={(e) =>
                                                                this.handleStar(
                                                                    e,
                                                                )
                                                            }
                                                            handleCancle={(e) =>
                                                                this.handleCancle(
                                                                    e,
                                                                )
                                                            }
                                                            handlePdfRun={(e) =>
                                                                this.handlePdfRun(
                                                                    e,
                                                                )
                                                            }
                                                            handleAppCopy={(
                                                                e,
                                                            ) =>
                                                                this.handleAppCopy(
                                                                    e,
                                                                )
                                                            }
                                                            handleChangeOwner={(
                                                                e,
                                                            ) =>
                                                                this.handleShowOwnerModal()
                                                            }
                                                            showBanks={(e) =>
                                                                this.showBanks(
                                                                    e,
                                                                )
                                                            }
                                                            handleActiveBank={(
                                                                e,
                                                            ) =>
                                                                this.handleActiveBank(
                                                                    e,
                                                                )
                                                            }
                                                            status2PercentageFn={(
                                                                e,
                                                            ) =>
                                                                status2Percentage(
                                                                    e,
                                                                )
                                                            }
                                                            currentProgressName={(
                                                                e,
                                                            ) =>
                                                                this.currentProgressName(
                                                                    e,
                                                                )
                                                            }
                                                            check={check}
                                                            activeId={activeId}
                                                            user={loggedInUser}
                                                            row_info={row_info}
                                                            show_info={
                                                                show_info
                                                            }
                                                        />
                                                    ),
                                            )}
                                        </InfiniteScroll>
                                    </div>
                                </div>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        );

        const rightContent = (
            <div className="content-area-right-col">
                {show_info && (
                    <div className="content-area">
                        <TransactionDetails
                            appDataId={appData.id}
                            app_data={appData}
                        ></TransactionDetails>
                    </div>
                )}
            </div>
        );

        const updateOwnershipModal = (
            <ReactModal
                isOpen={this.state.showOwnerModal}
                contentLabel="Minimal Modal Example"
                className="modal-change-owrnship"
            >
                <h4 className="text-center owner-title">Change Ownership</h4>
                <div className="row">
                    <div className="col-md-12 dd-change-ownership">
                        {pci_admin && (
                            <SelectDropDown
                                isSearchable={true}
                                options={organization_options}
                                name="owner_organization"
                                placeholder="Select organization"
                                value={owner_selected_organization}
                                handleChange={(selected) => {
                                    this.handleOwnerOrganizationChange(
                                        selected.value,
                                    );
                                }}
                            />
                        )}
                        <SelectDropDown
                            isSearchable={true}
                            options={user_options}
                            name="owner_users"
                            placeholder="Select user"
                            value={selected_owner}
                            handleChange={(selected) => {
                                this.handleOwnerChange(selected.value);
                            }}
                        />
                    </div>
                    <div className="col-md-12 owner-button-group">
                        <button
                            className="btn btn-danger close_modal"
                            onClick={this.handleCloseOwnerModal}
                        >
                            Close
                        </button>
                        <button
                            className="btn btn-success save_modal"
                            onClick={(e) => this.handleUpdateOwner()}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </ReactModal>
        );
        const hideAppInfo = () => {
            this.setState({ activeId: null });
        };
        return (
            <div className="website-wrapper application-page">
                {show_spinner ? (
                    <div className="loader-wrap">
                        <p className="loader"></p>
                    </div>
                ) : (
                    ""
                )}

                {show_info && activeId ? (
                    <MobileAppDetailHeader
                        user={loggedInUser}
                        show_info={this.state.show_info}
                        activeId={this.state.activeId}
                        onLogout={this.logout}
                        hideAppInfo={(e) => hideAppInfo(e)}
                        showBanks={this.showBanks}
                        header_user_name={header_user_name}
                        resetfilter={() =>
                            this.LeftProgressionFilter("reset_filters")
                        }
                        handleCancle={() => this.handleCancle(activeId)}
                        handlePdfRun={() => this.handlePdfRun(activeId)}
                        handleAppCopy={() => this.handleAppCopy(activeId)}
                        handleChangeOwner={() => this.handleShowOwnerModal()}
                        handleEditApplication={() =>
                            this.handleEditApplication()
                        }
                        currentRoute={this.props.currentRoute}
                        tabShowActive={(route) =>
                            this.props.tabShowActive(route)
                        }
                    />
                ) : (
                    ""
                )}
                <div className="d-flex page-bottom-wrap" id="wrapper">
                    <div id="page-content-wrapper">
                        {updateOwnershipModal}
                        {showAlert && (
                            <div>
                                <AlertForSendSignature
                                    showAlert={showAlert}
                                    heading={alertHeader}
                                    message={alertMessage}
                                    variant="success"
                                    handleDismissible={() => {
                                        this.setState({ showAlert: false });
                                    }}
                                />
                            </div>
                        )}

                        <div className="row" onClick={(e) => this.hideSearch()}>
                            <div className="col-lg-12 text-right header-actions">
                                <ul>
                                    {check.length == 1 && (
                                        <li>
                                            <a
                                                name={
                                                    appData != undefined &&
                                                    appData.progression !=
                                                        undefined &&
                                                    appData.progression
                                                        .status != "Cancelled"
                                                        ? "cancel"
                                                        : "Re-Activate"
                                                }
                                                onClick={(e) =>
                                                    this.navigate(e)
                                                }
                                                className={
                                                    appData.id == undefined
                                                        ? "is_disable"
                                                        : "is_enable"
                                                }
                                            >
                                                <i
                                                    className="fa fa-scissors"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                {appData != undefined &&
                                                appData.progression !=
                                                    undefined &&
                                                appData.progression.status !=
                                                    "Cancelled"
                                                    ? "Cancel Preapp"
                                                    : " Re-Activate Preapp"}
                                            </a>
                                        </li>
                                    )}
                                    {check.length == 1 && (
                                        <li>
                                            <a
                                                name="ownership"
                                                onClick={(e) =>
                                                    this.navigate(e)
                                                }
                                                className={
                                                    appData.id == undefined
                                                        ? "is_disable"
                                                        : "is_enable"
                                                }
                                            >
                                                <i
                                                    className="fa fa-exchange"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Change Ownership
                                            </a>
                                        </li>
                                    )}
                                    {check.length == 1 && (
                                        <li>
                                            <a
                                                name="Re-run"
                                                onClick={(e) =>
                                                    this.navigate(e)
                                                }
                                                className={
                                                    appData.id == undefined
                                                        ? "is_disable"
                                                        : "is_enable"
                                                }
                                            >
                                                <i
                                                    className="fa fa-repeat"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Re-Run Application
                                            </a>
                                        </li>
                                    )}
                                    {check.length == 1 && (
                                        <li>
                                            <a
                                                name="Copy Application"
                                                onClick={(e) =>
                                                    this.navigate(e)
                                                }
                                                className={
                                                    appData.id == undefined
                                                        ? "is_disable"
                                                        : "is_enable"
                                                }
                                            >
                                                <i
                                                    className="fa fa-copy"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Copy Application
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>

                        <div className="container-fluid container-fluid-right">
                            <ReactTooltip
                                effect="solid"
                                place="right"
                                className="tool-tip"
                            />
                            <div className="row main-first-row resizer-divided">
                                <div
                                    className="sidebar-navb-new"
                                    id="sidebar-wrapper-new"
                                >
                                    <a
                                        className="navb-button"
                                        onClick={(e) => this.handleMenu()}
                                    >
                                        {mobileMenu && filterToggle ? (
                                            <i className="fa fa-angle-left" />
                                        ) : (
                                            <i className="fa fa-angle-right" />
                                        )}
                                    </a>

                                    <div
                                        className={
                                            filterToggle
                                                ? "list-group list-group-flush"
                                                : "list-group list-group-flush d-none"
                                        }
                                    >
                                        <nav
                                            className={
                                                mobileMenu
                                                    ? "navb show-sidemenu"
                                                    : "navb"
                                            }
                                        >
                                            <ul>
                                                <li>
                                                    <a
                                                        name="reset_filters"
                                                        className={
                                                            left_progression_filter ===
                                                            "active"
                                                                ? "active"
                                                                : ""
                                                        }
                                                        onClick={() =>
                                                            this.LeftProgressionFilter(
                                                                "active",
                                                            )
                                                        }
                                                        data-tip="Processing"
                                                    >
                                                        <i
                                                            className="fa fa-circle reset_filters active"
                                                            aria-hidden="true"
                                                            style={{
                                                                color: "#b4a7d6",
                                                            }}
                                                        />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        name="reset_filters"
                                                        className={
                                                            left_progression_filter ===
                                                            "inactive"
                                                                ? "active"
                                                                : ""
                                                        }
                                                        onClick={() =>
                                                            this.LeftProgressionFilter(
                                                                "inactive",
                                                            )
                                                        }
                                                        data-tip="Not Processing"
                                                    >
                                                        <i
                                                            className="fa fa-circle reset_filters"
                                                            aria-hidden="true"
                                                            style={{
                                                                color: "#b6d7a8",
                                                            }}
                                                        />
                                                    </a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                {isMobile ? (
                                    <>
                                        {show_info && activeId ? (
                                            <>{rightContent}</>
                                        ) : (
                                            <>{leftContent}</>
                                        )}
                                    </>
                                ) : (
                                    <div className="resize-wrapper merchants-resize-wrapper">
                                        <div className="resizer">
                                            {leftContent}
                                        </div>
                                        <ColumnResizer
                                            className="columnResizer"
                                            minWidth={0}
                                        />
                                        {/* <div className="rightContentWrap">
                      {rightContent}
                    </div> */}
                                        {this.state.showMerchantInfoLoader ===
                                        true ? (
                                            <div className="rightContentWrap">
                                                <p className="loader"></p>
                                            </div>
                                        ) : (
                                            <div className="rightContentWrap">
                                                {rightContent}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {banks.length ? (
                        <BanksModal
                            show={this.state.show_banks}
                            handleClose={(e) => this.handleClose()}
                            banks={banks}
                            bankChange={(e) => this.bankChange()}
                            appId={this.state.activeId}
                        />
                    ) : null}

                    <div
                        className={
                            todo
                                ? "tasks-drawer tasks-drawer-show"
                                : "tasks-drawer"
                        }
                    >
                        <a
                            className="tasks-drawer-close"
                            onClick={(e) => this.closeDrawer()}
                        >
                            <i className="fa fa-close"></i>
                        </a>
                        <div className="tasks-drawer-in">
                            <div className="tasks-drawer-header">
                                <p>TASKS</p>
                                <h3>
                                    {user != null && user.name != undefined
                                        ? user.name + " List"
                                        : " List"}
                                </h3>
                            </div>
                            <div className="tasks-drawer-add">
                                <div className="tasks-drawer-add-top">
                                    <a onClick={(e) => this.addTasks()}>
                                        <span>+</span> <em>Add a task</em>
                                    </a>
                                    <span className="v-ellipsis-dots">
                                        <i
                                            className="fa fa-ellipsis-v"
                                            aria-hidden="true"
                                            onClick={(e) =>
                                                this.handleFilterMenu()
                                            }
                                        ></i>
                                    </span>
                                    {FilterMenu && (
                                        <div className="v-ellipsis-dots-box">
                                            <p>Filter by</p>
                                            <ul>
                                                <li>
                                                    <a
                                                        name="incompleted"
                                                        onClick={(e) =>
                                                            this.changeFilter(e)
                                                        }
                                                    >
                                                        In-Complete{" "}
                                                        {filterBy == "no" ? (
                                                            <i className="fa fa-check-circle"></i>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        name="completed"
                                                        onClick={(e) =>
                                                            this.changeFilter(e)
                                                        }
                                                    >
                                                        Completed{" "}
                                                        {filterBy == "yes" ? (
                                                            <i className="fa fa-check-circle"></i>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                                {add_todo && (
                                    <div className="tasks-drawer-add-bottom">
                                        <form>
                                            <div className="tasks-add">
                                                <input
                                                    type="text"
                                                    name="todo_text"
                                                    value={this.state.todo_text}
                                                    onChange={(e) =>
                                                        this.todoChange(e)
                                                    }
                                                ></input>
                                            </div>
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                                name="todo_text"
                                                value={this.state.todo_text}
                                                onClick={(e) =>
                                                    this.todoSubmit(e)
                                                }
                                            >
                                                Save
                                            </button>
                                        </form>
                                    </div>
                                )}
                                {todo_list && (
                                    <div className="tasks-drawer-add-bottom todo-list">
                                        {Object.entries(todo_list).map(
                                            (element, k) => (
                                                <div key={element[1].id}>
                                                    <div className="tasks-add">
                                                        <div>
                                                            <input
                                                                type="text"
                                                                onClick={(e) =>
                                                                    this.editTodo(
                                                                        element[1]
                                                                            .id,
                                                                    )
                                                                }
                                                                name="todo_text"
                                                                value={
                                                                    element[1]
                                                                        .text
                                                                }
                                                                onChange={(e) =>
                                                                    this.handleTodo(
                                                                        e,
                                                                        k,
                                                                    )
                                                                }
                                                            ></input>
                                                            <div className="tasks-drawer-checkbox">
                                                                <label
                                                                    className="checkbox-label"
                                                                    data-toggle="tooltip"
                                                                    title="click to mark as complete"
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        name="term_and_condition"
                                                                        onChange={(
                                                                            e,
                                                                        ) =>
                                                                            this.completeTodo(
                                                                                e,
                                                                                element[1],
                                                                            )
                                                                        }
                                                                        checked={
                                                                            element[1]
                                                                                .is_completed ==
                                                                            "yes"
                                                                        }
                                                                    ></input>
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {todo_id ==
                                                        element[1].id && (
                                                        <div className="action-btn">
                                                            <i
                                                                className="fa fa-pencil-square icon-4x btn btn-primary"
                                                                aria-hidden="true"
                                                                onClick={(e) =>
                                                                    this.todoUpdate(
                                                                        e,
                                                                        element[1],
                                                                    )
                                                                }
                                                            >
                                                                {" "}
                                                                Update
                                                            </i>
                                                            <i
                                                                className="fa fa-trash icon-4x btn btn-danger"
                                                                aria-hidden="true"
                                                                onClick={(e) =>
                                                                    this.removeTodo(
                                                                        element[1]
                                                                            .id,
                                                                    )
                                                                }
                                                            ></i>
                                                        </div>
                                                    )}
                                                </div>
                                            ),
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default MerchantAppList;
